<template>
  <div class="cooperative-school">
    <el-form ref="form" :model="form" :inline="true">
      <el-form-item label="修改后用户账号">
        <el-input v-model="form.afterAccount" clearable placeholder="请输入用户名" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item label="校区名搜索">
        <el-input v-model="form.eduName" clearable placeholder="请输入校区名" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item label="域名搜索">
        <el-input v-model="form.domain" clearable placeholder="请输入域名" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item label="当前用户账号">
        <el-input v-model="form.currentAccount" clearable placeholder="请输入当前用户账号" style="width: 200px"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userName" label="姓名"></el-table-column>
      <el-table-column prop="eduName" label="校区"></el-table-column>
      <el-table-column prop="domain" label="域名"></el-table-column>
      <el-table-column prop="createdTime" label="修改时间"></el-table-column>
      <el-table-column prop="originAccount" label="修改前用户账号"></el-table-column>
      <el-table-column prop="afterAccount" label="修改后用户账号"></el-table-column>
      <el-table-column prop="currentAccount" label="当前用户账号"></el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>

    </el-table>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

  </div>
</template>

<script>
// import {
//   adminGetHistoryUserNameList
// } from "@/api/admin";

import {
  api_userSelectChangeRecord
} from '@/api/javaApi'


export default {
  name: "look-order",
  data() {
    return {
      form: {
        afterAccount: '',
        eduName: '',
        domain: '',
        currentAccount: '',
      },
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20

    }
  },
  mounted() {
    this.adminGetHistoryUserNameList()

  },
  methods: {
    search() {
      this.page_no = 1;
      this.adminGetHistoryUserNameList()
    },
    adminGetHistoryUserNameList() {
      api_userSelectChangeRecord({
        account: this.form.afterAccount,
        eduName: this.form.eduName,
        domain: this.form.domain,
        currentAccount: this.form.currentAccount,
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size
        }
      }).then((res) => {
        this.tableData = res.content
        this.total = res.totalSize
        console.log(res)
      })
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetHistoryUserNameList();
    }
  }

};
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 10px;
  background-color: #fff;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .btn {
    margin-top: 15px;
  }
}
</style>
